/**
 * Cabeceras de la plantilla de carga masiva VIGENTE (V4).
 *
 * Fuente única para los tres lugares que necesitan conocerlas:
 *   1. `ShipmentBulkUpload.handleFileSubmit` — valida que el archivo subido las traiga.
 *   2. `legacyBulkTemplate` — recibe esta lista para traducir el formato anterior.
 *   3. Los tests — verifican que la tabla de alias cubra exactamente estas cabeceras.
 *
 * DEBEN coincidir exactamente con el array `headers` de
 * `exportFormatoShipmentXLSX_V2WithCoords` (exports.tsx): el match es por TEXTO, no por
 * letra de columna. Si acá se renombra una y en la tabla de alias de
 * `legacyBulkTemplate` no, esa columna se leería vacía para los archivos del sistema
 * anterior — sin error visible. El test `legacyBulkTemplate.test.ts` cruza ambas listas
 * justamente para que eso no pase inadvertido.
 *
 * No incluye las columnas condicionales ("Oficina origen", "Servicio"), que solo existen
 * cuando el contrato tiene más de una opción, ni las opcionales que el parser lee de
 * forma tolerante ("Punto de referencia (si es domicilio)").
 */
export const BULK_TEMPLATE_REQUIRED_HEADERS = [
  'Número de guía aliada',
  'Tipo de documento Remitente (Opcional)',
  'Nº de Documento Remitente (Opcional)',
  'Nombre Remitente (Opcional)',
  '¿Es destinatario favorito? (Sí/No)',
  'Identificador destinatario favorito',
  'Tipo de documento destinatario',
  'Nº de Documento destinatario',
  'Nombre destinatario',
  'Telefono destinatario',
  'Correo destinatario',
  'Tipo de entrega',
  'Ciudad/Localidad destino (si es domicilio)',
  'Código de tienda destino (si es entrega en tienda)',
  'Dirección destino (si es domicilio)',
  'Latitud destino (si es domicilio)',
  'Codigo Postal (Opcional)',
  'Longitud destino (si es domicilio)',
  'Categoria del contenido',
  'Código de categoría',
  'Cantidad de Piezas',
  'Peso en Kg por pieza',
  'Dimension Alto por pieza',
  'Dimension Ancho por pieza',
  'Dimension Largo por pieza',
  'Valor declarado por pieza',
  'Observaciones',
]
